/*
 * @Description:
 * @Author: yunhe
 * @Date: 2020-10-22 11:49:04
 * @LastEditors: yunhe
 * @LastEditTime: 2020-10-28 15:45:23
 */
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import JoinGroup from '@/components/JoinGroup'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name: 'JoinGroup',
      component: JoinGroup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js